import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { login, loginLoading, register, registerLoading } from '../../actions/authActions';
import Login from './Login';
import Register from './Register';
import { useHistory } from "react-router-dom";
import { notification } from 'antd';
import { LoadScript } from '@react-google-maps/api';
import LoadScriptOnlyIfNeeded from '../../Components/MapComponent/LoadScriptOnlyIfNeeded';
import { mapOptions } from '../../Components/MapComponent/MapConfig';

export const Authentication = (props) => {

  const [registerFlag, setRegisterFlag] = useState(false)
  const [loginFlag, setLoginFlag] = useState(true);
  const [passwordFlag, setPasswordFlag] = useState(false);

  const [loadingFlag, setLoadingFlag] = useState(false)

  const [responseNotification, setresponseNotification] = useState({
    status: false,
    success: false,
    message: ""
})

  const setLoginScreen = () => {
    setLoginFlag(true)
    setRegisterFlag(false)
    setPasswordFlag(true)
    setPasswordFlag(false)
  }

  const setRegisterScreen = () => {
    setRegisterFlag(true)
    setLoginFlag(false)
    setPasswordFlag(false)
    // console.warn("Ca;;ed");
  }

  const setPasswordScreen = () => {
    setRegisterFlag(false)
    setLoginFlag(false)
    setPasswordFlag(true)
  }

  const history = useHistory()

  // console.warn("you came from: ", history)

  useEffect(()=>{
    const state = history.location.state
    if(state && state.activeTab==='1') {
      setLoginScreen()
    } else if (state && state.activeTab==='2') {
      setRegisterScreen()
    }
  }, [history.location.state])

  useEffect(() => {
    if(props.loginRet) {
        if(props.loginRet.success){
            let token = props.loginRet.token
            if(token){
                Cookies.set("token_medical_auth", token)
                history.push("/dashboard")
            }
        } else {
          openNotificationWithIcon(props.loginRet.message)
        }
        props.loginLoading()
    }
  }, [props.loginRet])

  useEffect(() => {
    if(props.registerRet) {
        if(props.registerRet.success){
          notification["success"]({
            message: 'Registration Successful',
            description:
              'Please wait for verification by our team',
          })
        } else {
          openNotificationWithIcon(props.registerRet.message)
        }
        props.registerLoading()
    }
  }, [props.registerRet])


  const openNotificationWithIcon = (message) => {
    notification["error"]({
      message: message ? (message?.toLowerCase() === "incorrect email or password!" ? "Incorrect email or password" : message) : 'Invalid Credentials',
    //   description:
    //     'This is the content of the notification. This is the content of the notification. This is the content of the notification.',
    });
  };

  useEffect(() => {
    if(props.regsiterLoadingFlag || props.registerLoadingFlag)
      setLoadingFlag(true)
    else
      setLoadingFlag(false)
  }, [props.loginLoadingFlag, props.regsiterLoadingFlag])

  useEffect(() => {
    const interval = setInterval(() => {
        if(responseNotification.status)
            setresponseNotification({
                status: false,
                success: false,
                message: ""
            })
    }, 3000);
    
    return () => clearInterval(interval); 
  }, [responseNotification.status])

  return (
    <div>
      <LoadScriptOnlyIfNeeded
        googleMapsApiKey={mapOptions.GoogleMapsAPI}
        libraries={["places"]}
        onUnmount={() => {console.error("LoadScript component unmounted")}}
      >
        <div className="authentication-container">
                {loginFlag && <Login
                  login = {props.login}
                  loginRet = {props.loginRet}
                  loginLoading = {props.loginLoading}
                  loginLoadingFlag = {props.loginLoadingFlag}
                  setRegisterScreen={setRegisterScreen}
                  setPasswordScreen={setPasswordScreen}
                  responseNotification={responseNotification}
                  handleClose = {props.handleClose}
                />}
                {registerFlag && <Register 
                  register = {props.register}
                  registerRet = {props.registerRet}
                  registerLoading = {props.registerLoading}
                  registerLoadingFlag = {props.registerLoadingFlag}
                  handleClose = {props.handleClose}
                  setLoginScreen={setLoginScreen}
                />}
                {/* {passwordFlag && <ResetPassword
                  register = {props.register}
                  registerRet = {props.registerRet}
                  registerLoading = {props.registerLoading}
                  registerLoadingFlag = {props.registerLoadingFlag}
                  handleClose = {props.handleClose}
                  setRegisterScreen={setRegisterScreen}
                  setLoginScreen={setLoginScreen}
                />} */}
        </div>
      </LoadScriptOnlyIfNeeded>;
    </div>
  )
};

const mapStateToProps = (state) => ({
  loginRet: state.authStore.loginRet,
  loginLoadingFlag: state.authStore.loginLoading,
  registerRet: state.authStore.registerRet,
  regsiterLoadingFlag: state.authStore.regsiterLoading
});

export default connect(mapStateToProps, {
  login,
  loginLoading,
  register,
  registerLoading
})(Authentication);
